"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const utils_1 = require("../utils");
// Define the containerVariants using the `cva` function from class-variance-authority.
// The variants allow for the customization of the container's size.
const containerVariants = (0, class_variance_authority_1.cva)("", // Base styles (empty for now, could be used for global styles like padding or margin)
{
    variants: {
        size: {
            boxed: "max-w-[1424px] px-3 mx-auto", // Boxed variant with max-width and horizontal padding
            fluid: "w-full", // Fluid variant with full width
        },
    },
    defaultVariants: {
        size: "boxed", // Default size variant is "boxed"
    },
});
// The Container component is a functional component that uses the containerVariants to style the div.
const Container = ({ className, size, children, ...props }) => {
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(containerVariants({ size }), className), ...props }, children));
};
exports.Container = Container;
